import { red } from "utils/color"

export const errorStyle = {
  marginBottom: 10,
  color: red,
  fontSize: 10,
  marginTop: -17,
}
